/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptions interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptions(value) {
    if (!('UserId' in value) || value['UserId'] === undefined)
        return false;
    if (!('UserName' in value) || value['UserName'] === undefined)
        return false;
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    if (!('IsGuest' in value) || value['IsGuest'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptionsFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'UserId': json['UserId'],
        'UserName': json['UserName'],
        'Token': json['Token'],
        'IsGuest': json['IsGuest'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptionsToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptionsToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'UserId': value['UserId'],
        'UserName': value['UserName'],
        'Token': value['Token'],
        'IsGuest': value['IsGuest'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateFromSocialAuthenticateFromSocialDtoKongregateLoginOptions.js.map